import { isNil } from 'lodash';

import { ClaimActionPlanTaskResult, Insight } from '~/components/Claim/Insights/types';

export const generateActionPlanMarkdown = (insight: Insight) => {
  let claimActionPlan = insight?.metadata?.claim_action_plan as ClaimActionPlanTaskResult[];
  // this is for backward compatibility with old insights
  if (isNil(claimActionPlan)) {
    claimActionPlan = insight?.metadata?.actions as ClaimActionPlanTaskResult[];
  }

  if (!claimActionPlan || !Array.isArray(claimActionPlan)) {
    throw new Error('Invalid input: Expected an array of action plan items');
  }

  // Status emoji mapping
  const statusEmojis: Record<string, string> = {
    done: '✅',
    to_do: '🔴',
    not_applicable: '⚪',
  };

  // Status text mapping
  const statusText: Record<string, string> = {
    done: 'DONE',
    to_do: 'TO DO',
    not_applicable: 'NOT APPLICABLE',
  };

  const markdownLines = ['# Claim Action Plan', '', '---', ''];
  claimActionPlan.forEach((task) => {
    const { id, title, status, description, status_reason } = task;
    const emoji = statusEmojis[status.toLowerCase()] || '❓';
    const text = statusText[status] || status.toUpperCase();
    markdownLines.push(`### ${id}. ${title}`, '');
    markdownLines.push(`**Status:** ${emoji} ${text}`, '');
    if (description) {
      markdownLines.push(`**Description:**`, description, '');
    }
    if (status_reason) {
      markdownLines.push(`**Status Reason:**`, status_reason, '');
    }
    markdownLines.push('---', '');
  });
  return markdownLines.join('\n');
};
